import { render } from "./SemenIbvk.vue?vue&type=template&id=7ae6ba7c"
import script from "./SemenIbvk.vue?vue&type=script&lang=js"
export * from "./SemenIbvk.vue?vue&type=script&lang=js"

import "./SemenIbvk.vue?vue&type=style&index=0&id=7ae6ba7c&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__